<template>
    <div>
		<preloader v-show="loading"></preloader>
        <div v-show="sended" class="form__content form__mortgage-docs form__mortgage-docs-sended">
            <div class="h2 _mb-32">Заявка успешно отправлена</div>
        </div>
        <div v-show="!sended" class="form__content form__mortgage-docs">
            <div class="h2 _mb-32">Остались вопросы?</div>
            <div class="p1 _mb-32">Отправьте заявку и мы свяжемся с вами</div>

            <div class="form__row">
                <div class="form__item form__item-wide">
                    <vue-suggestion
                        v-model="$v.fullName.$model"
                        label="Фамилия и имя"
                        :class="{'_invalid': $v.fullName.$error, '_focus': fullName.length > 0}"
                        method="fio"
                        :parts="['SURNAME', 'NAME']"
                    >
                    </vue-suggestion>
                    <label
                        v-show="$v.fullName.$model.length > 0"
                        for="fullName"
                        class="callback-form__field-label"
                    >
                        Фамилия и имя
                    </label>
                    <p class="form-error" v-if="$v.fullName.$error && !$v.fullName.required">Поле «Фамилия и имя» обязательно для заполнения</p>
                    <p class="form-error" v-if="$v.fullName.$error && !$v.fullName.onlyCyr">Поле «Фамилия и имя» не должно содержать латинские буквы и спецсимволы</p>
                    <p class="form-error" v-if="$v.fullName.$error && !$v.fullName.minLength">Поле «Фамилия и имя» не может быть содержать менее 5 символов</p>
                </div>
            </div>

            <div class="form__row">
                <div class="form__col">
                    <div class="form__item">
                        <d-select
                            id="city"
                            v-model="city"
                            :items="cities"
                            label="Город проживания"
                            :class="{'_invalid': $v.city.$error}"
                        />
                        <p class="form-error" v-if="$v.city.$error && !$v.city.required">Поле обязательно для заполнения</p>
                    </div>
                </div>
                <div class="form__col">
                    <div class="form__item">
                        <div class="form__input _focus">
                            <input id="phone" v-phone :data-value="phone" type="tel" class="d-input _focus-always" name="phone" v-mask="'+7 ###-###-##-##'" placeholder="+7" masked="true" v-model.lazy="phone" :class="{'_invalid': $v.phone.$error || phoneStartsAtEight}">
                            <label class="form__label">Номер телефона</label>
                        </div>
                        <p class="form-error" v-if="$v.phone.$error && !$v.phone.required">Поле обязательно для заполнения</p>
                        <p class="form-error" v-if="$v.phone.$error && $v.phone.required && !$v.phone.minLength">Проверьте корректность номера.</p>
                        <p class="form-error" v-if="phoneStartsAtEight">Вводите номер телефона с цифры 9</p>
                    </div>
                </div>
            </div>


            <div class="_mb-24 _mt-24-12">
                <div @click="agreement = !agreement" class="checkbox">
                    <input v-model="agreement" type="checkbox" class="checkbox__input" name="agreement" :class="{'_invalid': $v.agreement.$error}">
                    <label class="checkbox__label">
                        <p>Я соглашаюсь с&nbsp;<a target="_blank" href="/upload/medialibrary/638/Aprovement.pdf" class="link">условиями&nbsp;использования персональных&nbsp;данных</a> и&nbsp;подтверждаю согласие на&nbsp;использование <a href="#" class="link" @click.stop.prevent="$modal.show('agreement_pep')">простой электронной подписи</a>.</p>
                    </label>
                </div>
                <p class="form-error" v-if="$v.agreement.$error">Поле обязательное для заполнения.</p>
            </div>

            <div @click="sendPhone" class="button button_green">Оставить заявку</div>

            <div class="form__lock">
                <span class="ico ico-safety ico_color_gray-dark ico_size_16 _mr-12"></span>
                <span class="text-small form__lock-text">Мы защищаем ваши персональные данные, не&nbsp;раскрываем их третьим лицам и&nbsp;не&nbsp;распространяем без&nbsp;вашего согласия на&nbsp;это, если иное не&nbsp;предусмотрено законодательством</span>
            </div>

            <modal-with-yandex-captcha
                :requested="modalSmsShow"
                :phone="phone"
                :endpoint="requestType"
                @closeCaptchaSms="modalSmsShow = false"
                @smsConfirmed="sendForm"
            />

            <d-modal
                v-cloak
                name="agreement_pep"
                popup-title="Соглашение об использовании простой электронной подписи"
                size="wide"
            >
                <p class="d-modal__text p1">
                    <slot name="agreement_pep"></slot>
                </p>
                <br>
            </d-modal>
        </div>
    </div>

</template>

<script>
    // import {mask} from 'vue-the-mask'
    import {validationMixin} from 'vuelidate'
    import {required, minLength} from 'vuelidate/lib/validators'
    import {onlyCyr} from '../../assets/js/vue/validations'
    import {getCitiesV2} from '../../assets/js/utils'
    import axios from 'axios';

    export default {
        name: 'MortgageDocumentsForm',
        mixins: [validationMixin],
        data() {
            return {
                requestType: 'mortgageRequiredDocumentsForm',
                fullName: '',
                phone: '',
                city: '',
                agreement: '',
                code: '',
                cities: [],
                currentTime: 0,
                startTimeCodeLive: 29,
                phoneStartsAtEight: false,
                codeError: false,
                sessid: window.config.bitrix_sessid,
                tryToSend: false,
                sended: false,
                loading: false,
                modalSmsShow: false
            }
        },
        validations() {
            return {
                fullName: {
                    required,
                    onlyCyr,
                    minLength: minLength(5)
                },
                city: {
                    required
                },
                phone: {
                    required,
                    minLength: minLength(16)
                },
                agreement: {
                    isAgreed: value => value
                }
            }
        },
        methods: {
            sendPhone() {
                this.tryToSend = true;
                this.$v.$touch();

                if (!this.$v.$invalid) {
                    this.modalSmsShow = true;
                }
            },
            sendForm() {
                this.$v.$touch();
                this.tryToSend = true;

                if (!this.$v.$invalid) {
                    this.loading = true;
                    let data = {
                        data: {
                            type: this.requestType,
                            attributes: {
                                fullName: this.fullName,
                                phone: this.phone.replace(/\D/g, ''),
                                city: this.city,
                                agreement: true
                            }
                        }
                    }
                    axios.post('/rest/v1/mortgage/requiredDocuments?sessid=' + this.sessid, data)
                        .then(() => {
                            this.sended = true;
                            window.dmpkitdl.push({event: 'mortgage-doc-full-fos-send'});
                        })
                        .finally(() => {
                            this.loading = false;
                        })
                }
            },
        },
        beforeMount() {
            getCitiesV2()
				.then(res => {
					this.cities = res.data.data.map(item => {
						return {
							const: item.id,
							title: item.attributes.name,
						}
					});

                    this.cities.map(city => {
                        if (city.title === 'Москва') {
                            this.city = city.const;
                        }
                    })
				})
        }
    }
</script>
